import { Component, EventEmitter, Output } from '@angular/core';
import { CcdlButtonComponent } from '@cpm-pr1618001/ng-design-lib';

@Component({
  selector: 'reset-update',
  templateUrl: './reset-update.component.html',
  styleUrl: './reset-update.component.scss',
  imports: [CcdlButtonComponent],
  standalone: true,
})
export class ResetUpdateComponent {
  @Output() signInViewEmitter: EventEmitter<void> = new EventEmitter<void>();

  signInViewClick(): void {
    this.signInViewEmitter.emit();
  }
}
